<mat-toolbar fxLayout="row" fxLayoutAlign="space-between center">
  <span class="font-size-16 font-weight-400">
    {{ 'GROUPS.FILTER.TITLE' | translate }}
  </span>
</mat-toolbar>

<form class="filter-content" [formGroup]="filtersForm" fusePerfectScrollbar>
  <input
    class="mt-4 input-legacy"
    formControlName="name"
    name="name"
    placeholder="{{ 'GROUPS.FILTER.NAME' | translate }}"
  />

  <mat-divider class="mt-16"></mat-divider>

  <div class="filter-subtitle mt-16">
    {{ 'GROUPS.FILTER.STATUS_FILTER.TITLE' | translate }}
  </div>

  <mat-form-field class="mt-16 w-100-p" appearance="legacy">
    <mat-select formControlName="archived">
      <mat-option [value]="false">{{ 'GROUPS.FILTER.STATUS_FILTER.ACTIVE' | translate }}</mat-option>
      <mat-option [value]="true">{{ 'GROUPS.FILTER.STATUS_FILTER.ARCHIVED' | translate }}</mat-option>
      <mat-option [value]="''">{{ 'GROUPS.FILTER.STATUS_FILTER.ALL' | translate }}</mat-option>
    </mat-select>
  </mat-form-field>
</form>
